import { TagKey } from '@xbcb/shared-types';
import { CurrentUser } from 'libs/hooks/useCurrentUser';

export const DRAWBACK_INGESTION_BUSINESS_UNIT = 'CbmsDrawbackIngestionTeam';

export const hasDrawbackIngestionAccess = (currentUser: CurrentUser): boolean =>
  Boolean(
    currentUser?.tags?.some(
      ({ key, value }: { key: string; value: string }) =>
        key === TagKey.STRATEGIC_BUSINESS_UNIT &&
        value === DRAWBACK_INGESTION_BUSINESS_UNIT,
    ),
  );
